var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.548 1.03906L15.33 3.93906V14.9671H4.9375V15.0031H15.3655V3.97556L12.548 1.03906Z",
    fill: "#909090"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5178 1H4.90625V14.964H15.3342V3.9365L12.5178 1Z",
    fill: "#F4F4F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3884 10.1307C11.3884 10.1307 12.9824 9.84168 12.9824 10.3862C12.9824 10.9307 11.9949 10.7092 11.3884 10.1307ZM10.2099 10.1722C9.9566 10.228 9.70978 10.3099 9.47339 10.4167L9.67339 9.96668C9.87339 9.51668 10.0809 8.90318 10.0809 8.90318C10.319 9.30524 10.5967 9.68245 10.9099 10.0292C10.6741 10.0643 10.4404 10.1124 10.2099 10.1732V10.1722ZM9.57889 6.92218C9.57889 6.44768 9.73239 6.31818 9.85189 6.31818C9.97139 6.31818 10.1059 6.37568 10.1104 6.78768C10.0714 7.20195 9.98466 7.61033 9.85189 8.00468C9.66941 7.67381 9.57521 7.30152 9.57839 6.92368L9.57889 6.92218ZM7.25439 12.1802C6.76539 11.8877 8.27989 10.9872 8.55439 10.9582C8.55289 10.9587 7.76639 12.4862 7.25439 12.1802ZM13.4479 10.4507C13.4429 10.4007 13.3979 9.84718 12.4129 9.87068C12.0023 9.86348 11.5919 9.89243 11.1864 9.95718C10.7933 9.56154 10.455 9.11508 10.1804 8.62968C10.3533 8.12933 10.4581 7.60798 10.4919 7.07968C10.4774 6.47968 10.3339 6.13568 9.87389 6.14068C9.41389 6.14568 9.34689 6.54818 9.40739 7.14718C9.46661 7.54971 9.57839 7.94274 9.73989 8.31618C9.73989 8.31618 9.52739 8.97768 9.24639 9.63568C8.96539 10.2937 8.77339 10.6387 8.77339 10.6387C8.28468 10.7976 7.82466 11.0339 7.41089 11.3387C6.99889 11.7222 6.83139 12.0167 7.04839 12.3112C7.23539 12.5652 7.88989 12.6227 8.47489 11.8562C8.78519 11.4599 9.06913 11.0437 9.32489 10.6102C9.32489 10.6102 10.2169 10.3657 10.4944 10.2987C10.7719 10.2317 11.1074 10.1787 11.1074 10.1787C11.1074 10.1787 11.9219 10.9982 12.7074 10.9692C13.4929 10.9402 13.4549 10.4997 13.4499 10.4517",
    fill: "#DD2025"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4766 1.03906V3.97556H15.2931L12.4766 1.03906Z",
    fill: "#909090"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5156 1V3.9365H15.3321L12.5156 1Z",
    fill: "#F4F4F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.81db913799eae23fc6531b7c90553b06.svg";
export { ForwardRef as ReactComponent };